import CardHolderView from './CardHolderView';
export default CardHolderView;